exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul[data-v-f8b9a12e]{list-style:none}li a[data-v-f8b9a12e]{font-weight:500;font-size:14px;text-decoration:none;color:#ccc}ul li span[data-v-f8b9a12e]{text-align:right;font-weight:400}.exportFormatWrap[data-v-f8b9a12e]{position:relative}.exportFormat[data-v-f8b9a12e]{position:absolute;top:0;padding:0 10px;border:2px solid #ccc;left:-1em;line-height:2em;border-radius:6px;background:#4d4d4c}", ""]);

// exports
